import cn from "classnames";
import { useState, useMemo } from "react";

import { Select } from "src/shared/ui/Select";
import coinIcon from "src/assets/icons/coin.svg";
import freeIcon from "src/assets/icons/freeCoin.png";
import useStores from "src/hooks/useStores";
import useWindowSize from "src/hooks/useWindowSize";
import {bets, freeBets} from "src/store/gameStore/constants/bets";

import { useStyles } from "./styles";

interface IBetSelect {}

export const BetSelect = ({}: IBetSelect) => {
    const classes = useStyles();
    const { lobbyStore } = useStores();
    const betConfig = lobbyStore.betConfig.value;
    const { width } = useWindowSize();

    const isFreePlay = document.location.href.indexOf('lobby-free-play') > 0;

    const curBets = isFreePlay ? freeBets : bets;

    const betOptions = useMemo(
        () =>
            curBets.reduce((accum, item) => {
                const newBetItem = {
                    value: item,
                    label: item.toString(),
                    icon: (
                        <img src={isFreePlay ? freeIcon : coinIcon} className={classes.betSelectIcon} />
                    ),
                };
                return [...accum, newBetItem];
            }, []),
        []
    );

    return (
        <Select<number>
            value={betConfig}
            onChange={(value) => {
                lobbyStore.setBetConfigValue(value);
            }}
            options={betOptions}
            renderEmptyLabel={() => {
                return <div>Empty</div>;
            }}
            renderLabel={(option) => {
                return (
                    <div className={classes.betSelectLabelWrapper}>
                        <div className={classes.betSelectLabelIcon}>
                            {option.icon}
                        </div>
                        <span className={cn(classes.betSelectLabel, {[classes.betSelectLabelFree]: isFreePlay})}>
                            {option.label}
                        </span>
                    </div>
                );
            }}
            renderOption={(option, selected) => {
                return (
                    <div
                        className={cn(classes.betOption, {
                            [classes.betOptionSelected]: selected,
                        })}
                    >
                        <div
                            className={cn(classes.betDropdownOptionIcon, {
                                [classes.betDropdownOptionIconSelected]:
                                    selected,
                            })}
                        >
                            {option.icon}
                        </div>
                        <span className={cn(classes.betDropdownOptionLabel)}>
                            {+option.label < 1
                                ? option.value.toFixed(2)
                                : option.value}
                        </span>
                        <span
                            className={cn(classes.betRankDropdownOptionLabel)}
                        >
                            {+option.label >= 1 && !isFreePlay &&
                                (width < 1100 ? "+ R" : "+ Rank")}
                        </span>
                    </div>
                );
            }}
        />
    );
};
